import React, { useEffect, useState, memo } from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "2rem",
    marginLeft: "0.5rem",
  },
  headerRow: {
    backgroundColor: "#e0e0e0",
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  itemRow: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    border: "1px solid #e0e0e0",
  },
  amountText: {
    fontWeight: "bold",
    fontSize: "1.05rem",
  },
  fieldLabel: {
    fontWeight: 600,
    fontSize: "0.85rem",
    marginBottom: theme.spacing(0.5),
  },
}));

const NewChangeOrderItem = ({ setItems, items }) => {
  const classes = useStyles();

  // const [items, setItems] = useState([
  //   {
  //     id: Date.now(),
  //     itemName: "",
  //     unit: "",
  //     quantity: 0,
  //     unitPrice: 0.0,
  //     amount: 0.0,
  //   },
  // ]);

  const handleItemChange = (id, field, value) => {
    setItems((prev) =>
      prev.map((it) => {
        if (it.id !== id) return it;
        const updated = { ...it, [field]: value };
        const quantity = parseFloat(updated.quantity) || 0;
        const unitPrice = parseFloat(updated.unitPrice) || 0;
        updated.amount = parseFloat((quantity * unitPrice).toFixed(2));
        return updated;
      })
    );
  };

  const handleAddItem = () => {
    setItems((prev) => [
      ...prev,
      {
        id: Date.now(),
        itemName: "",
        unit: "",
        quantity: 0,
        unitPrice: 0.0,
        amount: 0.0,
      },
    ]);
  };

  const handleDeleteItem = (id) => {
    setItems((prev) =>
      prev.length > 1 ? prev.filter((i) => i.id !== id) : prev
    );
  };

  const columns = [
    { key: "itemName", label: "Line Item", xs: 3 },
    { key: "unit", label: "Unit Type", xs: 2 },
    { key: "quantity", label: "Quantity", xs: 2 },
    { key: "unitPrice", label: "Unit Price ($)", xs: 2 },
    { key: "amount", label: "Amount ($)", xs: 2 },
  ];

  return (
    <div className={classes.container}>
      <Grid container spacing={2} className={classes.headerRow}>
        {columns.map((c) => (
          <Grid item key={c.key} xs={c.xs}>
            <Typography className={classes.fieldLabel}>{c.label}</Typography>
          </Grid>
        ))}
        <Grid item xs={1} />
      </Grid>
      {items.map((item) => (
        <Grid
          key={item.changeOrderId || item.id}
          container
          spacing={2}
          className={classes.itemRow}
          alignItems="center"
        >
          <Grid item xs={3}>
            <TextField
              fullWidth
              key={item.id}
              size="small"
              placeholder="Enter Item"
              value={item.itemName}
              onChange={(e) =>
                handleItemChange(item.id, "itemName", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              fullWidth
              key={item.id}
              size="small"
              placeholder="Unit"
              value={item.unit}
              onChange={(e) =>
                handleItemChange(item.id, "unit", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              fullWidth
              key={item.id}
              size="small"
              type="number"
              value={item.quantity}
              onChange={(e) =>
                handleItemChange(item.id, "quantity", e.target.value)
              }
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              fullWidth
              key={item.id}
              size="small"
              type="number"
              value={item.unitPrice}
              onChange={(e) =>
                handleItemChange(item.id, "unitPrice", e.target.value)
              }
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              key={item.id}
              fullWidth
              size="small"
              value={item.amount}
              disabled
              type="number"
            />
          </Grid>
          <Grid item xs={1}>
            <DeleteIcon
              key={item.id}
              onClick={() => handleDeleteItem(item.id)}
              style={{
                fontSize: "1.2rem",
                color: items.length === 1 ? "#ccc" : "red",
                cursor: items.length === 1 ? "not-allowed" : "pointer",
              }}
            />
          </Grid>
        </Grid>
      ))}
      <button
        className="secondaryButton"
        type="button"
        onClick={handleAddItem}
        style={{ marginTop: "0.5rem" }}
      >
        + Add Item
      </button>
    </div>
  );
};

export default memo(NewChangeOrderItem);
